/* Hülyet Naturèl – Theme-Skript. Nutzt die Shopify Cart AJAX API und die Section Rendering API. */
(function () {
  'use strict';

  var T = window.theme || {};
  var R = T.routes || {};
  var S = T.strings || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Hinweis-Meldung ---------- */
  var toastTimer;
  function toast(message) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 3000);
  }

  /* ---------- Cart API ---------- */
  var jsonHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function request(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || S.error);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function cartAdd(formData) {
    return request(R.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
  }

  function cartChange(line, quantity) {
    return request(R.cartChange, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function setBadge(count) {
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = !count;
    });
    $$('[data-cart-open]').forEach(function (b) {
      var base = b.getAttribute('data-label') || '';
      b.setAttribute('aria-label', count ? base + ' (' + count + ')' : base);
    });
  }

  /* Warenkorb-Schublade und Warenkorbseite neu laden */
  function refreshCart() {
    var jobs = [];
    jobs.push(fetch(R.cartJs, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setBadge(cart.item_count); }));

    var drawerInner = $('[data-cart-drawer-inner]');
    if (drawerInner) {
      jobs.push(fetch(R.root + (R.root.indexOf('?') > -1 ? '&' : '?') + 'sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var fresh = $('[data-cart-drawer-inner]', tmp);
          if (fresh) drawerInner.innerHTML = fresh.innerHTML;
        }));
    }

    var page = $('[data-cart-page]');
    if (page) {
      jobs.push(fetch(R.cart)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-page]', doc);
          if (fresh) page.innerHTML = fresh.innerHTML;
        }));
    }
    return Promise.all(jobs);
  }

  /* ---------- Schublade ---------- */
  var lastFocus = null;
  function drawerEl() { return $('#CartDrawer'); }
  function openDrawer() {
    var d = drawerEl();
    if (!d) return false;
    lastFocus = document.activeElement;
    $('#CartOverlay').classList.add('open');
    d.classList.add('open');
    document.body.classList.add('lock');
    var first = $('[data-cart-close]', d);
    if (first) first.focus();
    return true;
  }
  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    $('#CartOverlay').classList.remove('open');
    d.classList.remove('open');
    document.body.classList.remove('lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function afterAdd(title) {
    return refreshCart().then(function () {
      if (T.cartType === 'page') {
        window.location.href = R.cart;
        return;
      }
      if (!openDrawer()) toast((S.added || '').replace('__TITLE__', title || ''));
    });
  }

  /* ---------- Hinzufügen (Produktseite und Produktkarten) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var isProduct = form.matches('[data-product-form]');
    var isQuick = form.matches('[data-quick-form]');
    if (!isProduct && !isQuick) return;
    e.preventDefault();

    var btn = $('[type="submit"]', form);
    var errorBox = $('[data-form-error]', form);
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    if (btn) btn.setAttribute('aria-disabled', 'true');

    var title = form.getAttribute('data-title') ||
      (($('h1') || {}).textContent || '').trim();

    cartAdd(new FormData(form))
      .then(function () { return afterAdd(title); })
      .catch(function (err) {
        if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
        else toast(err.message);
      })
      .then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  /* ---------- Klicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var open = t.closest('[data-cart-open]');
    if (open) {
      if (T.cartType === 'page' || !drawerEl()) return; /* Link zur Warenkorbseite bleibt */
      e.preventDefault();
      openDrawer();
      return;
    }
    if (t.closest('[data-cart-close]')) { closeDrawer(); return; }

    var qtyBtn = t.closest('[data-cart-qty]');
    if (qtyBtn) {
      var next = parseInt(qtyBtn.getAttribute('data-current'), 10) + parseInt(qtyBtn.getAttribute('data-delta'), 10);
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var focusKey = qtyBtn.getAttribute('data-delta');
      cartChange(line, Math.max(0, next))
        .then(refreshCart)
        .then(function () {
          var again = $('[data-cart-qty][data-line="' + line + '"][data-delta="' + focusKey + '"]:not([disabled])');
          if (again) again.focus();
        })
        .catch(function (err) { toast(err.message); refreshCart(); });
      return;
    }

    var rm = t.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      cartChange(parseInt(rm.getAttribute('data-cart-remove'), 10), 0)
        .then(refreshCart)
        .catch(function (err) { toast(err.message); });
      return;
    }

    var menuBtn = t.closest('[data-menu-toggle]');
    if (menuBtn) {
      var menu = $('#MobileMenu');
      var isOpen = menu.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', String(isOpen));
      return;
    }

    var searchBtn = t.closest('[data-search-toggle]');
    if (searchBtn) {
      var bar = $('#SearchBar');
      var isOpenS = bar.classList.toggle('open');
      searchBtn.setAttribute('aria-expanded', String(isOpenS));
      if (isOpenS) { var q = $('input[type="search"]', bar); if (q) q.focus(); }
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('[data-qty-input]', step.closest('.qty'));
      var v = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10)));
      input.value = v;
      syncQtyButtons(step.closest('.qty'));
      return;
    }

    var thumb = t.closest('[data-media-thumb]');
    if (thumb) { showMedia(thumb.getAttribute('data-media-thumb')); return; }

    /* Dropdown-Navigation schließen, wenn außerhalb geklickt wird */
    $$('.nav details[open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
    $$('.filters details[open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
  });

  document.addEventListener('keydown', function (e) {
    var d = drawerEl();
    if (d && d.classList.contains('open')) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key === 'Tab') {
        var f = $$('a[href], button:not([disabled]), input, textarea, select', d).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    if (e.key === 'Escape') {
      $$('.nav details[open], .filters details[open]').forEach(function (x) { x.removeAttribute('open'); });
    }
  });

  /* ---------- Menge auf der Produktseite ---------- */
  function syncQtyButtons(group) {
    if (!group) return;
    var input = $('[data-qty-input]', group);
    var v = parseInt(input.value, 10) || 1;
    $$('[data-qty-step]', group).forEach(function (b) {
      var s = parseInt(b.getAttribute('data-qty-step'), 10);
      b.disabled = (s < 0 && v <= 1) || (s > 0 && v >= 99);
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-qty-input]')) {
      var v = Math.max(1, Math.min(99, parseInt(e.target.value, 10) || 1));
      e.target.value = v;
      syncQtyButtons(e.target.closest('.qty'));
    }
    if (e.target.closest('[data-auto-submit]') || e.target.matches('[data-auto-submit]')) {
      var formId = e.target.getAttribute('form');
      var f = formId ? document.getElementById(formId) : e.target.form;
      if (f) f.submit();
    }
  });

  /* ---------- Produktseite: Varianten und Galerie ---------- */
  function showMedia(id) {
    var wrap = $('[data-gallery-main]');
    if (!wrap) return;
    $$('[data-media-id]', wrap).forEach(function (m) { m.hidden = String(m.getAttribute('data-media-id')) !== String(id); });
    $$('[data-media-thumb]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(String(b.getAttribute('data-media-thumb')) === String(id)));
    });
  }

  function initProduct(section) {
    var dataEl = $('[data-product-json]', section);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', form);
    var btn = $('[data-add-btn]', form);
    var priceEl = $('[data-price]', section);
    var soldTag = $('[data-sold-tag]', section);
    var errorBox = $('[data-form-error]', form);
    syncQtyButtons($('.qty', form));

    function selected() {
      return $$('fieldset.v', form).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function update() {
      var opts = selected();
      var match = null;
      variants.forEach(function (v) {
        if (v.options.every(function (o, i) { return opts[i] === o; })) match = v;
      });
      if (errorBox) { errorBox.hidden = true; }
      if (!match) {
        btn.disabled = true;
        btn.textContent = S.unavailable;
        return;
      }
      idInput.value = match.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      btn.disabled = !match.available;
      btn.textContent = match.available ? S.addToCart : S.soldOut;
      if (soldTag) soldTag.hidden = match.available;
      if (priceEl) {
        priceEl.innerHTML = match.compare
          ? '<s class="price-was">' + match.compare + '</s> <span class="price-now">' + match.price + '</span>'
          : '<span class="price-now">' + match.price + '</span>';
      }
      if (match.media) showMedia(match.media);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('fieldset.v input', form).forEach(function (i) { i.addEventListener('change', update); });
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- Warenkorbseite: Notiz speichern ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-note]')) {
      fetch(R.cart + '/update.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ note: e.target.value }) });
    }
  });
})();
